export default __webpack_public_path__ + "static/media/bg.1ec2e74f.png";